import React from 'react';
import { TUTORIAL_MANAGE_COURIERS_ORDER_HIDE } from '../../TutorialsContainer';
import TutorialManager, { Step } from '../../TutorialManager';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useTranslation } from 'react-i18next';
import PIEText from '@src/shared/components/PIEText';
const ManageCouriersOrderHideTutorial = () => {
  const { isMobileDevice } = useDeviceDetect();
  const { t } = useTranslation();

  const renderStep1 = () => {
    return (
      <div>
        <PIEText
          text={t('onboarding_couriers.SPOTLIGHT_TITLE_HIDE_COURIERS_TUTORIAL')}
          size={'var(--xds-font-size-14)'}
          fontWeight="var(--xds-font-weight-bold)"
          color="var(--xds-color-content-inverse)"
        />
        <PIEText
          text={t('onboarding_couriers.SPOTLIGHT_TEXT_HIDE_COURIERS_TUTORIAL')}
          size={'var(--xds-font-size-14)'}
          fontWeight="var(--xds-font-weight-regular)"
          color="var(--xds-color-content-inverse)"
        />
      </div>
    );
  };

  const steps: Array<Step> = [
    {
      targetElementSelector: '#manage-courier-list > div > div',
      content: () => renderStep1(),
      tooltipSettings: ({ closeTutorial }) => ({
        modClickAway: false,
        position: 'bottom',
        showClose: true,
        modFluid: isMobileDevice ? true : false,
        panelWidth: isMobileDevice ? 280 : 0,
        align: isMobileDevice ? 'end' : 'center',
        onClose: () => {
          closeTutorial();
        },
      }),
    },
  ];

  const onBeforeStartHandler = () => {};

  const onAfterEndHandler = () => {};

  return (
    <TutorialManager
      onBeforeStart={onBeforeStartHandler}
      onAfterEnd={onAfterEndHandler}
      steps={steps}
      useTooltip={true}
      tutorialID={TUTORIAL_MANAGE_COURIERS_ORDER_HIDE}
    />
  );
};

export default ManageCouriersOrderHideTutorial;
